import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Tunga is creative, kind, patient with little ones, and very good at what she does. I am amazed at how fast she gets the pictures edited and ready for us!',
  author: 'Maria K.',
  type: 'Family & Newborn Sessions'
}, {
  quote: "Tunga photographed me and my boyfriend's anniversary and I was thrilled with her results. She took incredible photos and gave the final edited ones to me within 24 hours. Her price was more than fair and she was more than willing to help recreate the poses I wanted. I would recommend her to take any pictures!",
  author: 'Lauren R.',
  type: 'Anniversary Session'
}, {
  quote: 'Incredible photographer! Creative, attentive, and amazing at capturing beautiful, spontaneous moments. We had a great time and highly recommend her!',
  author: 'Priscilla W.',
  type: 'Photo Session'
}, {
  quote: 'Thank you so much for beautifully capturing such a special and meaningful moment for us. These photos will be treasured forever.',
  author: 'Aagiinaa M.',
  type: 'Couples Session'
}];
// Create pairs of testimonials for rotation
const pairs: Array<[number, number]> = [];
for (let i = 0; i < testimonials.length; i += 2) {
  pairs.push([i, (i + 1) % testimonials.length]);
}
export function Testimonials() {
  const [activePairIndex, setActivePairIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setActivePairIndex(prev => (prev + 1) % pairs.length);
    }, 20000);
    return () => clearInterval(interval);
  }, []);
  const currentPair = pairs[activePairIndex];
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-148">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-149" />

      <div className="max-w-7xl mx-auto px-6" data-id="element-150">
        <div className="text-center mb-16" data-id="element-151">
          <span className="text-gold text-sm tracking-widest uppercase font-medium mb-4 block" data-id="element-152">
            Kind Words
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal" data-id="element-153">
            Client Love
          </h2>
        </div>

        <div className="relative min-h-[280px] md:min-h-[240px]" data-id="element-154">
          <AnimatePresence mode="wait" data-id="element-155">
            <motion.div key={activePairIndex} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 1.2,
            ease: 'easeInOut'
          }} className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16" data-id="element-156">
              {currentPair.map(testimonialIndex => {
              const item = testimonials[testimonialIndex];
              return <div key={testimonialIndex} className="text-center px-4 md:px-8" data-id="element-157">
                    <div className="flex justify-center mb-6" data-id="element-158">
                      <Quote className="w-8 h-8 text-gold/40" data-id="element-159" />
                    </div>
                    <p className="font-serif text-lg md:text-xl italic text-charcoal/80 mb-6 leading-relaxed" data-id="element-160">
                      &ldquo;{item.quote}&rdquo;
                    </p>
                    <div data-id="element-161">
                      <p className="font-medium text-charcoal uppercase tracking-widest text-sm mb-1" data-id="element-162">
                        {item.author}
                      </p>
                      <p className="text-gold text-xs uppercase tracking-wider" data-id="element-163">
                        {item.type}
                      </p>
                    </div>
                  </div>;
            })}
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Dot indicators */}
        <div className="flex justify-center gap-3 mt-12" data-id="element-164">
          {pairs.map((_, index) => <button key={index} onClick={() => setActivePairIndex(index)} className={`w-2 h-2 rounded-full transition-all duration-500 ${index === activePairIndex ? 'bg-gold w-6' : 'bg-charcoal/20 hover:bg-charcoal/40'}`} aria-label={`Show testimonials ${index + 1}`} data-id="element-165" />)}
        </div>
      </div>
    </section>;
}